import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']

export const ReasonContainer = styled(Box)`
  width: 100%;

  > span {
    font-weight: bold;
  }

  > ul {
    margin: 0px;
    padding: 0px;
    padding-left: 18px;
    font-size: 14px;
    color: ${darkColor};
    font-weight: 400;
  }

  li {
    line-height: 165%;
  }
`

export const Label = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 165%;
  color: ${darkColor};
  margin: 0;
`
